<style scoped>
  @import '../../../assets/css/eprendersdk.min.css';
</style>
<style lang="less">
  @import "./ShowMedia.less";
</style>
<template>
  <div class="show-media" :key='key'>
    <div class="show-media-info" v-for="(item, index) in mediaList" :key="index">
      <img v-if="!item.url" src="../../../assets/images/img_default02.png" alt="">
      <template v-if='item.camera===4'>
        <div v-if="item.mtype===1" id='demoImage' >
          <img :src="item.url" alt="" @load='change3DImg(item)' style="visibility: hidden;">
          <span class="fullScreen" @click.stop='fullScreenHandle(item,"change3DImg")' v-show='isangle'>
            <img src="../../../assets/images/fullScreen.png" alt="" srcset="">
          </span>
        </div>
        <div v-if="item.mtype===2" id='d3Video' >
          <img :src="item.url_thumb" alt="" @load='change3DVideo(item)'  style="visibility: hidden;">
          <!-- <img src="../../../assets/images/play.png" alt="" class="play"> -->
          <span class="fullScreen" @click.stop='fullScreenHandle(item,"change3DVideo")'  v-show='isangle'>
            <img src="../../../assets/images/fullScreen.png" alt="" srcset="">
          </span>
        </div>
      </template>
      <template v-else>
        <img v-if="item.mtype===1" :src="item.url" alt="" :onerror="defaultImg" @click="previewImageFn(item.url)">
        <video v-if="item.mtype===2"   :src="item.url" controls="controls" :poster="item.url_thumb" playsinline x5-playsinline="true"></video>
      </template>
      <h4><label class="theme-color">{{item.photoTypeText}}</label><span v-if="item.cameraTypeText">（{{item.cameraTypeText}}）</span></h4>
      <!--暂无时间信息,暂无地址信息-->
      <p><van-icon name="underway-o" />拍摄时间：{{item.showTime || '未上传时间信息'}}</p>
      <template v-if="item.show_location">
        <template v-if="(item.auth_travel_manage===1||item.auth_travel_manage===0)">
          <p v-if="item.location"><van-icon name="location-o" />拍摄地点：{{item.location}}</p>
          <p v-else @click="transformHandle(item._id,item.type)">
          <van-icon name="location-o" />拍摄地点：<i style="color: #1686FD;">点击查看详细地址</i></p>
        </template>
        <p v-else><van-icon name="location-o" />拍摄地点：位置管理权限已关闭</p>
      </template>
      <p v-else><van-icon name="location-o" />拍摄地点：拍摄地址已关闭</p>
    </div>

    <div id='demoVideo' v-show='isshow'></div>
    <span id="close" v-show='isshow'><img @click='closeHandle' src="../../../assets/img/ep_mode_close.png" alt=""></span>
    </div>
</template>

<script>
import ShowMedia from './ShowMedia.js'
export default {
  ...ShowMedia
}
</script>
